<div class="overflow-hidden primary-card-container rounded-lg cursor-pointer hover:shadow-md transition-shadow">
    <div class="flex flex-row items-center justify-between gap-x-4 border-b dark:border-white/10 border-gray-300 pb-2">
        <div class="flex-1 flex flex-row items-center gap-x-2 min-w-0">
            <div
                class="size-10 shrink-0 rounded-lg bg-fuchsia-100 dark:bg-fuchsia-900/30 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-fuchsia-600 dark:text-fuchsia-400">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6" />
                    <path d="M16 13H8" />
                    <path d="M16 17H8" />
                    <path d="M10 9H8" />
                </svg>
            </div>
            <div class="flex flex-col min-w-0 flex-1">
                <div class="text-sm font-medium text-primary truncate">{{ brief.briefTitle }}</div>
                <div class="text-xs text-secondary">Monitoring Brief</div>
            </div>
        </div>
    </div>
    <dl class="divide-y divide-gray-200 dark:divide-white/10 px-2 pb-2 text-sm">
        <div class="flex justify-between gap-x-4 py-2">
            <dt class="text-secondary">Created</dt>
            <dd class="text-primary">{{ formatDate(brief.createdDate) }}</dd>
        </div>
        <div class="flex justify-between gap-x-4 py-2">
            <dt class="text-secondary">Monitoring</dt>
            <dd class="text-primary">{{ formatDate(brief.monitorStart) }} - {{ formatDate(brief.monitorUntil) }}</dd>
        </div>
        @if (brief.creatorListId) {
        <div class="flex justify-between gap-x-4 py-2">
            <dt class="text-secondary">Creator Count</dt>
            <dd class="text-primary truncate">{{ brief.creatorList?.creators?.length || 0 }}</dd>
        </div>
        }
    </dl>
    <div class="flex flex-row items-center justify-between gap-x-4">
        @if (brief.creatorListId) {
        <button class="primary-button w-full">View Results</button>
        } @else {
        <button (click)="selectCreatorGroup()" class="primary-button w-full">Select Creator Group</button>
        }
    </div>
</div>

@if (showGroupPicker()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6"
    (click)="showGroupPicker.set(false)">
    <div class="h-[70vh] w-full max-w-2xl overflow-hidden rounded-xl bg-white p-4 dark:bg-gray-900"
        (click)="$event.stopPropagation()">
        <rg-group-picker class="h-full w-full" [mode]="'attach-to-brief'"
            [briefContext]="{ kind: 'monitoring', briefId: brief.id }"
            (attached)="showGroupPicker.set(false)"></rg-group-picker>
    </div>
</div>
}